import { render, staticRenderFns } from "./CustomerUserEdit.vue?vue&type=template&id=f690c252"
import script from "./CustomerUserEdit.vue?vue&type=script&lang=ts"
export * from "./CustomerUserEdit.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports